import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../app-insights";
import Rootpage from "../RootPage";
import localisations from "shell/localisation";

function HomePage() {
    const homePageText = localisations.pages.home;

    return <Rootpage header={homePageText.heading}></Rootpage>;
}

export default withAITracking(reactPlugin, HomePage, "Home Page");
